export const mapListObjectByKey = (key, listObjects, includes) => {
  return listObjects
    .filter(
      obj => includes === undefined || includes?.some(item => item === obj[key])
    )
    .reduce((prev, curr) => {
      const value = curr[key];
      prev[value] = prev[value] ?? [];
      prev[value].push(curr);
      return prev;
    }, {});
};
